export default __webpack_public_path__ + "static/media/banner2.4faaf119.jpg";